export default __webpack_public_path__ + "static/media/ayaloloo-buses.0e51ba92.png";